import { API_BASE_URL } from '../../../lib/config';
import * as React from 'react';
import { useState } from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';
import CheckIcon from '@mui/icons-material/Check';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import RefreshIcon from '@mui/icons-material/Refresh';
import Modal from 'react-bootstrap/Modal';
import DownloadIcon from '@mui/icons-material/Download';
import Dropdown from 'react-bootstrap/Dropdown';
import RevisionQuote from '../revisequote';
import { useParams } from 'react-router-dom';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import { postRequest, deleteRequest } from '../../../lib/api';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import { AuthContext } from '../../../authContext/context';
import Swal from 'sweetalert2';
import Notes from '../Notes/note';
import jsPDF from 'jspdf';
 
function MyVerticallyCenteredModal({ show, onHide, quoteData, leadData }) {
  const generatePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;

    // Header
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`Quote for LSS Estate Administration #${leadData?.lead_id || 'N/A'}`, 10, 20);

    // Subheading with legal fees total
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    const totalText = `Legal Fees from My Law Matters of £${(quoteData?.totalCost || 0).toFixed(2)} inc. VAT`;
    doc.text(totalText, 10, 35);

    // Thank you message
    doc.text('Thank you for choosing My Law Matters for your LSS Estate Administration needs.', 10, 50);

    // Create manual table since autoTable might have issues
    let yPosition = 65;

    // Table header
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPosition, 60, 8); // Description column
    doc.rect(70, yPosition, 30, 8); // Net column
    doc.rect(100, yPosition, 30, 8); // VAT column
    doc.rect(130, yPosition, 40, 8); // Total column

    doc.text('Description', 12, yPosition + 5);
    doc.text('Net', 82, yPosition + 5);
    doc.text('VAT', 112, yPosition + 5);
    doc.text('Total', 142, yPosition + 5);

    yPosition += 8;

    // Table data rows
    doc.setFont('helvetica', 'normal');
    const legalFee = parseFloat(quoteData?.mlmLegalCost || 0);
    const vat = parseFloat(quoteData?.vat || 0);
    const legalTotal = parseFloat(quoteData?.totalCost || 0);

    // Legal Fee row
    doc.rect(10, yPosition, 60, 8);
    doc.rect(70, yPosition, 30, 8);
    doc.rect(100, yPosition, 30, 8);
    doc.rect(130, yPosition, 40, 8);

    doc.text('Legal Fees', 12, yPosition + 5);
    doc.text(`£${legalFee.toFixed(2)}`, 72, yPosition + 5);
    doc.text(`£${vat.toFixed(2)}`, 102, yPosition + 5);
    doc.text(`£${legalTotal.toFixed(2)}`, 132, yPosition + 5);

    yPosition += 8;

    // Total row
    doc.setFont('helvetica', 'bold');
    doc.rect(10, yPosition, 60, 8);
    doc.rect(70, yPosition, 30, 8);
    doc.rect(100, yPosition, 30, 8);
    doc.rect(130, yPosition, 40, 8);

    doc.text('TOTAL', 12, yPosition + 5);
    doc.text('', 72, yPosition + 5);
    doc.text('', 102, yPosition + 5);
    doc.text(`£${legalTotal.toFixed(2)}`, 132, yPosition + 5);

    // Additional details if needed
    const finalY = yPosition + 20;
    doc.setFontSize(10);
    doc.text('This quote is valid for 30 days from the date of issue.', 10, finalY);
    doc.text(`Generated on: ${new Date().toLocaleDateString('en-GB')}`, 10, finalY + 10);

    // Footer
    doc.setFontSize(8);
    doc.text('My Law Matters - Professional Legal Services', 10, doc.internal.pageSize.height - 20);

    // Save the PDF
    const filename = `LSS_Estate_Administration_Quote_${leadData?.lead_id || 'Quote'}.pdf`;
    doc.save(filename);

    Swal.fire('Success', 'Quote downloaded successfully!', 'success');
  };

  const handleDownload = () => {
    generatePDF();
  };

  return (
    <Modal show={show} onHide={onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6' }}>
        <Modal.Title id="contained-modal-title-vcenter">View Quote</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <Table bordered hover style={{ marginBottom: 0 }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th style={{ fontWeight: '600', width: '50%' }}>LSS Estate Administration</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>Net</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>VAT</th>
                <th style={{ fontWeight: '600', textAlign: 'center' }}>Gross</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Legal Fees</td>
                <td style={{ textAlign: 'center' }}>
                  £{(quoteData?.mlmLegalCost || 0).toFixed(2)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  £{(quoteData?.vat || 0).toFixed(2)}
                </td>
                <td style={{ textAlign: 'center', fontWeight: '600' }}>
                  £{(quoteData?.totalCost || 0).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        
        <div className="mt-4 text-center">
          <Button 
            variant="primary" 
            onClick={handleDownload}
            style={{ 
              minWidth: '120px',
              fontSize: '0.875rem'
            }}
          >
            <i className="fas fa-download me-2"></i>
            Download
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

// Revise Quote Modal Component
function ReviseQuoteModal({ show, onHide, leadData, estateCosts, authToken, onReviseQuote }) {
  const [legalFees, setLegalFees] = useState('');
  const [vat, setVat] = useState(0);
  const [gross, setGross] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  // Fetch latest calculation from final_leads_calculations when modal opens
  React.useEffect(() => {
    if (show && leadData?.lead_id) {
      const fetchLatestCalculation = async () => {
        try {
          setLoadingData(true);
          console.log('📡 Fetching latest calculation for LSS Revise Modal...');

          const res = await fetch(`${API_BASE_URL}private/getFinalLeadCalculations`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
              lead_id: leadData.lead_id
            })
          });

          const result = await res.json();

          if (result.status === 200 && result.data && result.data.length > 0) {
            // Use the latest calculation (first item in array)
            const latestCalc = result.data[0];
            const currentLegalFees = latestCalc.totals?.total?.net || 0;

            console.log('✅ Using latest calculation from final_leads_calculations:', currentLegalFees);
            setLegalFees(currentLegalFees.toString());
            calculateVatAndGross(currentLegalFees);
          } else {
            // Fallback to lead data if no calculation exists
            console.log('⚠️ No calculation found, using lead data');
            const currentLegalFees = leadData.mlmLegalCost || 0;
            setLegalFees(currentLegalFees.toString());
            calculateVatAndGross(currentLegalFees);
          }
        } catch (err) {
          console.error('❌ Error fetching latest calculation:', err);
          // Fallback to lead data
          const currentLegalFees = leadData.mlmLegalCost || 0;
          setLegalFees(currentLegalFees.toString());
          calculateVatAndGross(currentLegalFees);
        } finally {
          setLoadingData(false);
        }
      };

      fetchLatestCalculation();
    }
  }, [leadData, authToken, show]);
  
  // Calculate VAT and Gross when legal fees change
  const handleLegalFeesChange = (e) => {
    const value = e.target.value;
    setLegalFees(value);
    
    const numValue = parseFloat(value) || 0;
    calculateVatAndGross(numValue);
  };
  
  const calculateVatAndGross = (legalFeesAmount) => {
    const vatAmount = legalFeesAmount * 0.20; // 20% VAT
    const grossAmount = legalFeesAmount + vatAmount;
    
    setVat(vatAmount);
    setGross(grossAmount);
  };
  
  const handleReviseQuote = async () => {
    try {
      setIsLoading(true);
      const numLegalFees = parseFloat(legalFees) || 0;
      
      if (numLegalFees <= 0) {
        Swal.fire('Error', 'Please enter a valid legal fee amount', 'error');
        return;
      }
      
      const payload = {
        lead_id: leadData.lead_id,
        mlmLegalCost: numLegalFees,
        vat: vat,
        totalCost: gross
      };
      
      console.log('📝 Modal submitting revised quote:', payload);
      console.log('User entered legal fees:', numLegalFees);
      console.log('Calculated VAT:', vat);
      console.log('Calculated Total:', gross);
      
      // Call the onReviseQuote callback
      await onReviseQuote(payload);
      
      // Close modal
      onHide();
      
      // Reset form
      setLegalFees('');
      setVat(0);
      setGross(0);
    } catch (error) {
      console.error('❌ Modal error:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="revise-quote-modal">
      <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6' }}>
        <Modal.Title style={{ fontSize: '1.25rem', fontWeight: '600' }}>Revise Quote</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '1.5rem' }}>
        <div className="table-responsive">
          <Table bordered hover style={{ marginBottom: 0 }}>
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th style={{ 
                  fontWeight: '600', 
                  fontSize: '0.95rem',
                  padding: '12px 15px',
                  borderRight: '2px solid #dee2e6',
                  width: '40%'
                }}>
                  LSS Estate Administration <span style={{ color: '#dc3545', fontSize: '1.1rem' }}>+</span>
                </th>
                <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>Net</th>
                <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>VAT</th>
                <th style={{ fontWeight: '600', fontSize: '0.95rem', textAlign: 'center', padding: '12px 15px' }}>Gross</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ 
                  padding: '12px 15px',
                  fontSize: '0.95rem',
                  borderRight: '2px solid #dee2e6'
                }}>
                  Legal Fees
                </td>
                <td style={{ padding: '8px', textAlign: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <InputGroup style={{ width: '140px' }}>
                      <InputGroup.Text style={{ 
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #ced4da',
                        borderRight: '0',
                        fontWeight: '500'
                      }}>
                        £
                      </InputGroup.Text>
                      <Form.Control
                        type="number"
                        value={legalFees}
                        onChange={handleLegalFeesChange}
                        step="0.01"
                        min="0"
                        style={{ 
                          textAlign: 'right',
                          border: '1px solid #ced4da',
                          borderLeft: '0',
                          padding: '6px 10px',
                          fontWeight: '500'
                        }}
                        placeholder="0.00"
                        required
                      />
                    </InputGroup>
                  </div>
                </td>
                <td style={{ 
                  textAlign: 'center', 
                  padding: '12px 15px',
                  fontSize: '0.95rem',
                  fontWeight: '500',
                  backgroundColor: '#f8f9fa'
                }}>
                  £{vat.toFixed(2)}
                </td>
                <td style={{ 
                  textAlign: 'center', 
                  padding: '12px 15px',
                  fontSize: '0.95rem',
                  fontWeight: '600',
                  backgroundColor: '#e9ecef'
                }}>
                  £{gross.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: '1px solid #dee2e6', padding: '1rem 1.5rem' }}>
        <Button 
          variant="outline-secondary" 
          onClick={onHide}
          style={{ 
            paddingLeft: '20px', 
            paddingRight: '20px',
            fontWeight: '500'
          }}
        >
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={handleReviseQuote}
          disabled={isLoading}
          style={{ 
            paddingLeft: '20px', 
            paddingRight: '20px',
            fontWeight: '500',
            backgroundColor: '#dc3545',
            borderColor: '#dc3545'
          }}
        >
          {isLoading ? 'Updating...' : 'Revise Quote'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
 
 
export default function ViewLeadLssEstateAdministration() {
  const [modalShow, setModalShow] = React.useState(false);
  const [reviseModalShow, setReviseModalShow] = React.useState(false);
  const [leadData, setLeadData] = React.useState(null);
  const [contactAttempts, setContactAttempts] = React.useState(leadData?.contact_attempts || 0);
  const [estateCosts, setEstateCosts] = React.useState(null);
  const [latestBranchName, setLatestBranchName] = React.useState(null);
  const [quoteHistory, setQuoteHistory] = React.useState([]);
  const [revisionCount, setRevisionCount] = React.useState(0);
  const [selectedQuote, setSelectedQuote] = React.useState(null);
  const [partners, setPartners] = React.useState([]);
  const [quoteFeeData, setQuoteFeeData] = React.useState(null);
  const [loadingFee, setLoadingFee] = React.useState(false);
  const navigate = useNavigate();
  const authCtx = React.useContext(AuthContext);

  const { lead_id } = useParams()
 
  const handleUpdateContactAttempt = async (type) => {
  let updatedCount = contactAttempts;
 
  if (type === 'increase') updatedCount += 1;
  else if (type === 'reset') updatedCount = 0;
 
  try {
    const res = await postRequest('private/change-contact-status', {
      lead_id: lead_id,
      contact_attempts: updatedCount,
    }, authCtx.token);
 
    if (res.status === 200 || res.status === 'success') {
      setContactAttempts(updatedCount);
     // alert('Contact attempts updated successfully!');
    } else {
     // alert('Failed to update contact attempts.');
    }
  } catch (err) {
    console.error('Error:', err);
   // alert('Error updating contact attempts.');
  }
};
 
const handleDeleteLead = () => {
  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const res = await deleteRequest(`private/delete-lead/${lead_id}`, {}, authCtx.token);
        if (res.status === 200 || res.status === 'success') {
          Swal.fire(
            'Deleted!',
            'The lead has been deleted.',
            'success'
          );
          navigate('/leads');
        } else {
          Swal.fire('Error!', res.message || 'Failed to delete lead.', 'error');
        }
      } catch (err) {
        console.error('Error deleting lead:', err);
        Swal.fire('Error!', 'An error occurred while deleting the lead.', 'error');
      }
    }
  });
};

// Handle revise quote
const handleReviseQuote = async (payload) => {
  try {
    console.log('🎯 Revising LSS quote with payload:', payload);

    // Call the new backend endpoint for LSS Estate Administration
    const endpoint = `private/update-lss-estate-administration-quote/${lead_id}`;

    const res = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authCtx.token}`
      },
      body: JSON.stringify({
        mlmLegalCost: payload.mlmLegalCost
      })
    });

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`API call failed: ${res.status} - ${errorText}`);
    }

    const result = await res.json();

    if (result.status === 200) {
      console.log('✅ LSS Quote updated successfully');

      Swal.fire('Success', 'Quote revised successfully!', 'success');

      // Wait a moment for database to update, then refresh
      await new Promise(resolve => setTimeout(resolve, 500));

      // Refresh the lead data and quote history
      await fetchQuoteHistory();
      await fetchLatestQuote();
      await fetchLead();
    } else {
      Swal.fire('Error', result?.message || 'Failed to revise quote', 'error');
    }
  } catch (err) {
    console.error('❌ Error revising LSS quote:', err);
    Swal.fire('Error', err?.message || 'Something went wrong', 'error');
  }
};

// Regenerate Quote Handler
const handleRegenerateQuote = async () => {
  try {
    const confirmResult = await Swal.fire({
      title: 'Regenerate Quote?',
      text: 'This will create a new quote entry with current values.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, regenerate it!'
    });

    if (!confirmResult.isConfirmed) {
      return;
    }


    // Try to regenerate from rate card first
    let endpoint = `private/regenerate-lss-estate-administration-quote/${lead_id}`;
    let res = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authCtx.token}`
      }
    });

    // If rate card not found, use current lead values
    if (!res.ok && res.status === 404) {
      console.log('⚠️ LSS Rate card not found, using current lead values');

      // Use update endpoint with current values to create new entry
      endpoint = `private/update-lss-estate-administration-quote/${lead_id}`;
      const currentNet = quoteFeeData?.net || leadData?.mlmLegalCost || 0;

      res = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authCtx.token}`
        },
        body: JSON.stringify({
          mlmLegalCost: currentNet
        })
      });
    }

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`API call failed: ${res.status} - ${errorText}`);
    }

    const result = await res.json();

    if (result.status === 200) {
      // Refresh quote data from database
      await fetchQuoteHistory();
      await fetchLatestQuote();
      await fetchLead();

      Swal.fire('Success', 'Quote regenerated successfully!', 'success');
    } else {
      Swal.fire('Error', result?.message || 'Failed to regenerate quote', 'error');
    }
  } catch (err) {
    console.error('❌ Error regenerating LSS quote:', err);
    Swal.fire('Error', err?.message || 'Something went wrong', 'error');
  }
};

  const slugify = (text) =>
  text
    ?.toLowerCase()
    ?.replace(/ /g, '-')      // spaces to hyphen
    ?.replace(/[^\w-]+/g, '') // remove special chars
    ?.replace(/-+/g, '-');    // collapse consecutive hyphens to single hyphen

  // Calculate complexity based on net estate value
  const getComplexity = (netValue) => {
    if (!netValue) return 'Low';
    if (netValue < 325000) return 'Low';
    if (netValue >= 325000 && netValue < 650000) return 'Medium';
    return 'High';
  };

  // Get the cost based on complexity
  const getCostByComplexity = (complexity) => {
    if (!estateCosts || !estateCosts.costBreakdowns) return null;
    
    const costBreakdown = estateCosts.costBreakdowns.find(
      breakdown => breakdown.complexity === complexity
    );
    
    return costBreakdown || null;
  };


 // const lead_id = "L-10"; // Replace with dynamic id if needed

  // const fetchPartners = async () => {
  //   try {
  //     const res = await postRequest('private/partnersList', {}, authCtx.token);
  //     if (res?.status === 200 && res?.data) {
  //       setPartners(res.data);
  //     }
  //   } catch (err) {
  //     console.error('Error fetching partners:', err);
  //   }
  // };

  const fetchLead = React.useCallback(async () => {
    try {
      const res = await postRequest(`private/lead-overview-data/${lead_id}`, {}, authCtx.token);
      if (res.status === 'success') {
        setLeadData(res.data);
        // Load quote history and revision count
        setQuoteHistory(res.data.quote_history || []);
        setRevisionCount(res.data.revision_count || 0);
        console.log('Full lead data received:', res.data);
        console.log('Quote history:', res.data.quote_history);
        console.log('Revision count:', res.data.revision_count);
      }
    } catch (err) {
      console.error("Error fetching lead data", err);
    }
  }, [lead_id, authCtx.token]);

  React.useEffect(() => {
    fetchLead();
    // fetchPartners();
  }, [fetchLead]);

  // Fetch latest quote from database
  const fetchLatestQuote = async () => {
    if (!leadData?.lead_id) return;

    try {
      setLoadingFee(true);
      const res = await postRequest('private/getFinalLeadCalculations', {
        lead_id: leadData.lead_id
      }, authCtx.token);

      if (res.status === 200 && res.data && res.data.length > 0) {
        const latestQuote = res.data[0];
        console.log('🔍 LSS Latest Quote from API:', latestQuote);
        console.log('📋 Rate Card Type:', latestQuote.rate_card_type);
        console.log('🤝 Partner Name:', latestQuote.partner_name);
        console.log('🏢 Branch Name:', latestQuote.branch_name);

        const transformedData = {
          net: latestQuote.totals?.total?.net || 0,
          vat: latestQuote.totals?.total?.vat || 0,
          gross: latestQuote.totals?.total?.gross || 0,
          fees: latestQuote.fees || {},
          totals: latestQuote.totals || {},
          rate_card_type: latestQuote.rate_card_type || null,
          partner_name: latestQuote.partner_name || null,
          branch_name: latestQuote.branch_name || null
        };
        console.log('✅ LSS Transformed Data:', transformedData);
        setQuoteFeeData(transformedData);
      }
    } catch (err) {
      console.error('❌ Error fetching latest quote:', err);
    } finally {
      setLoadingFee(false);
    }
  };

  // Fetch quote history from final_leads_calculations
  const fetchQuoteHistory = async () => {
    if (!leadData?.lead_id) return;

    try {
      const res = await postRequest('private/getFinalLeadCalculations', {
        lead_id: leadData.lead_id
      }, authCtx.token);

      if (res.status === 200 && res.data) {
        console.log('✅ LSS Quote History Raw:', res.data);

        // Transform data to match expected format for Quotes tab
        const transformedHistory = res.data.map((calc, index) => ({
          mlmLegalCost: calc.totals?.total?.net || 0,
          vat: calc.totals?.total?.vat || 0,
          totalCost: calc.totals?.total?.gross || 0,
          created_at: calc.createdAt,
          branch_name: calc.branch_name || null,
          partner_name: calc.partner_name || null,
          rate_card_type: calc.rate_card_type || null,
          created_by: calc.created_by || 'User',
          revision_number: res.data.length - index,
          status: calc.is_active ? 'Current' : `Revision ${res.data.length - index}`,
          isCurrent: calc.is_active || false,
          calculation_source: calc.calculation_source
        }));

        console.log('✅ Transformed LSS Quote History:', transformedHistory);
        setQuoteHistory(transformedHistory);
      }
    } catch (err) {
      console.error('❌ Error fetching quote history:', err);
    }
  };

  // Fetch LSS Estate Administration fee (always Manchester branch)
  const fetchLssEstateAdministrationFee = async () => {
    if (!leadData) return;

    try {
      setLoadingFee(true);

      console.log('🎯 Fetching LSS Estate Administration fee');

      const payload = {
        lead_id: leadData.lead_id,
        product_id: leadData.product_id,
        net_value: leadData.net_value || 0,
        partner_id: leadData.partner_id
      };

      const res = await postRequest('private/getLssEstateAdministrationFee', payload, authCtx.token);

      if (res.status === 200 && res.data) {
        console.log('✅ Fee data received:', res.data);

        const transformedData = {
          net: res.data.net || 0,
          vat: res.data.vat || 0,
          gross: res.data.gross || 0,
          fees: res.data.fees || {},
          totals: res.data.totals || {}
        };

        setQuoteFeeData(transformedData);
      }
    } catch (err) {
      console.error('❌ Error fetching LSS Estate Administration fee:', err);
      Swal.fire('Error', 'Failed to fetch fee calculation', 'error');
    } finally {
      setLoadingFee(false);
    }
  };

  // Load quote data on component mount
  React.useEffect(() => {
    const loadQuoteData = async () => {
      if (!leadData?.lead_id || !authCtx.token) return;

      try {
        // Check if quote exists in database
        const res = await postRequest('private/getFinalLeadCalculations', {
          lead_id: leadData.lead_id
        }, authCtx.token);

        if (res.status === 200 && res.data && res.data.length > 0) {
          // Use existing quote from database
          console.log('📊 Using existing LSS quote from database');
          await fetchLatestQuote();
        } else {
          // Calculate new quote
          console.log('🆕 No LSS quote found in database - using lead data');
          // await fetchLssEstateAdministrationFee(); // Commented out - no rate card available

          // Set quoteFeeData from leadData if available
          if (leadData.mlmLegalCost || leadData.vat || leadData.totalCost) {
            setQuoteFeeData({
              net: leadData.mlmLegalCost || 0,
              vat: leadData.vat || 0,
              gross: leadData.totalCost || 0,
              fees: {},
              totals: {
                total: {
                  net: leadData.mlmLegalCost || 0,
                  vat: leadData.vat || 0,
                  gross: leadData.totalCost || 0
                }
              }
            });
          }
        }
      } catch (err) {
        console.error('❌ Error loading quote data:', err);
      }
    };

    loadQuoteData();
  }, [leadData?.lead_id, authCtx.token]);

  // Fetch quote history when leadData is loaded
  React.useEffect(() => {
    fetchQuoteHistory();
  }, [leadData?.lead_id, authCtx.token]);

  // Handle viewing quote details
  const handleViewQuoteDetail = async () => {
    console.log('📡 Fetching latest quote from final_leads_calculations...');

    if (!leadData?.lead_id) {
      console.error('❌ No lead_id available');
      return;
    }

    try {
      setLoadingFee(true);

      // Fetch latest quote from final_leads_calculations table
      const res = await postRequest('private/getFinalLeadCalculations', {
        lead_id: leadData.lead_id
      }, authCtx.token);

      console.log('✅ API Response:', res);

      if (res.status === 200 && res.data && res.data.length > 0) {
        const latestQuote = res.data[0];

        // Transform and display in modal
        const quoteForModal = {
          mlmLegalCost: latestQuote.totals?.total?.net || 0,
          vat: latestQuote.totals?.total?.vat || 0,
          totalCost: latestQuote.totals?.total?.gross || 0
        };

        console.log('💰 Displaying quote in modal:', quoteForModal);
        setSelectedQuote(quoteForModal);
        setModalShow(true);
      } else {
        console.log('⚠️ No quote found in final_leads_calculations');
        Swal.fire('Info', 'No quote calculation found. Please regenerate the quote.', 'info');
      }
    } catch (err) {
      console.error('❌ Error fetching quote:', err);
      Swal.fire('Error', 'Failed to fetch quote details', 'error');
    } finally {
      setLoadingFee(false);
    }
  };

  // Get LSS Estate Administration data from lssestateadministrationmanage table
  // React.useEffect(() => {
  //   async function fetchLssEstateAdminData() {
//       if (!leadData || !leadData.product_id) return;
//       
//       console.log('=== LSS ESTATE ADMINISTRATION MANAGE TABLE ===');
//       console.log('Lead Data:', leadData);
//       console.log('Product ID to match:', leadData.product_id);
//       
//       try {
//         // Step 1: Try different API endpoints for lssestateadministrationmanage table
//         console.log('🔍 Step 1: Trying different API endpoints...');
//         
//         let manageResponse = null;
//         
//         // Try option 1: getLssEstateAdministrationManage
//         try {
//           console.log('📡 Trying: private/getLssEstateAdministrationManage');
//           manageResponse = await postRequest('private/getLssEstateAdministrationManage', {
//             product_id: leadData.product_id
//           }, authCtx.token);
//           console.log('📋 getLssEstateAdministrationManage response:', manageResponse);
//         } catch (err1) {
//           console.log('❌ getLssEstateAdministrationManage failed:', err1.message);
//           
//           // Try option 2: getEstateAdministrationBranchManage but for LSS
//           try {
//             console.log('📡 Trying: private/getEstateAdministrationBranchManage (for LSS)');
//             manageResponse = await postRequest('private/getEstateAdministrationBranchManage', {
//               product_id: leadData.product_id
//             }, authCtx.token);
//             console.log('📋 getEstateAdministrationBranchManage response:', manageResponse);
//           } catch (err2) {
//             console.log('❌ getEstateAdministrationBranchManage failed:', err2.message);
//             
//             // Try option 3: Just get the latest entry
//             try {
//               console.log('📡 Trying: private/getLatestLssEstateAdministration');
//               manageResponse = await postRequest('private/getLatestLssEstateAdministration', {
//                 product_id: leadData.product_id
//               }, authCtx.token);
//               console.log('📋 getLatestLssEstateAdministration response:', manageResponse);
//             } catch (err3) {
//               console.log('❌ All API attempts failed');
//               console.log('Error 1:', err1.message);
//               console.log('Error 2:', err2.message);
//               console.log('Error 3:', err3.message);
//             }
//           }
//         }
//         
//         if (manageResponse.status === 'success' && manageResponse.data) {
//           console.log('✅ Found match in lssestateadministrationmanage table');
//           console.log('📊 Manage table data:', manageResponse.data);
//           
//           // Step 2: Get costbreakdown from the manage table data
//           let costBreakdowns = manageResponse.data.costBreakdowns;
//           let branchName = manageResponse.data.branch_name || 'Latest Branch';
//           
//           console.log('📊 Raw costBreakdowns:', costBreakdowns);
//           console.log('🏢 Branch name:', branchName);
//           
//           // Parse costBreakdowns if it's a JSON string
//           if (typeof costBreakdowns === 'string') {
//             try {
//               costBreakdowns = JSON.parse(costBreakdowns);
//               console.log('📊 Parsed costBreakdowns:', costBreakdowns);
//             } catch (parseErr) {
//               console.error('❌ Error parsing costBreakdowns:', parseErr);
//               costBreakdowns = [];
//             }
//           }
//           
//           // Step 3: Set the data for calculation
//           if (costBreakdowns && costBreakdowns.length > 0) {
//             console.log('✅ SUCCESS: Using costBreakdowns from manage table');
//             console.log('💰 Final costBreakdowns:', costBreakdowns);
//             
//             // Clean branch name
//             let cleanBranchName = branchName;
//             if (typeof cleanBranchName === 'string') {
//               cleanBranchName = cleanBranchName.replace(/@\w+/g, '');
//               cleanBranchName = cleanBranchName.replace(/branchName@?\w*/gi, '');
//               cleanBranchName = cleanBranchName.trim();
//             }
//             
//             setEstateCosts({
//               costBreakdowns: costBreakdowns,
//               branch_id: manageResponse.data.branch_id,
//               product_id: manageResponse.data.product_id
//             });
//             setLatestBranchName(cleanBranchName);
//             
//             console.log('✅ Estate costs set:', { costBreakdowns });
//             console.log('✅ Branch name set:', cleanBranchName);
//             return;
//           } else {
//             console.log('❌ No costBreakdowns found in manage table');
//           }
//         } else {
//           console.log('❌ No match found in lssestateadministrationmanage table');
//           console.log('   Status:', manageResponse?.status);
//           console.log('   Data:', manageResponse?.data);
//         }
//         
//         // Fallback: Try regular Estate Administration manage table 
//         console.log('🔄 Fallback: Trying regular Estate Administration manage table...');
//         try {
//           const fallbackResponse = await postRequest('private/getEstateAdministrationBranchManage', {
//             product_id: leadData.product_id
//           }, authCtx.token);
//           
//           console.log('📋 Fallback Estate Administration response:', fallbackResponse);
//           
//           if (fallbackResponse.status === 'success' && fallbackResponse.data) {
//             console.log('✅ Using regular Estate Administration costs as fallback');
//             
//             let costBreakdowns = fallbackResponse.data.costBreakdowns;
//             let branchName = fallbackResponse.data.branch_name || 'Estate Administration Branch';
//             
//             if (typeof costBreakdowns === 'string') {
//               costBreakdowns = JSON.parse(costBreakdowns);
//             }
//             
//             if (costBreakdowns && costBreakdowns.length > 0) {
//               setEstateCosts({
//                 costBreakdowns: costBreakdowns,
//                 branch_id: fallbackResponse.data.branch_id,
//                 product_id: fallbackResponse.data.product_id
//               });
//               setLatestBranchName(branchName + ' (Fallback)');
//               
//               console.log('✅ Using Estate Administration costs as fallback');
//               return;
//             }
//           }
//         } catch (fallbackErr) {
//           console.log('❌ Fallback also failed:', fallbackErr.message);
//         }
//         
//         // If no data found anywhere, set null
//         console.log('❌ No configuration found anywhere');
//         setEstateCosts(null);
//         setLatestBranchName('No Configuration Found');
//         
//       } catch (err) {
//         console.error('❌ Error fetching LSS Estate Administration manage data:', err);
//         setEstateCosts(null);
//         setLatestBranchName('Error Loading');
//       }
  //   }
  //
  //   fetchLssEstateAdminData();
  // }, [leadData, authCtx.token]);
 
  return (
    <>
      <BreadcrumbsWrapper
                   items={[
                   { label: 'Dashboard', path: '/dashboard' },
                   { label: 'Leads', path: '/leads' },
                   { label: 'View LSS Estate Administration', path: '' },
                 
                      ]}
                        />
                       <br></br>
   
      <div className='page-header pb-4 mb-4' style={{ borderBottom: '2px solid #e9ecef' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h1 className='mt-0 mb-2' style={{ color: '#2c3e50', fontSize: '1.75rem', fontWeight: '600' }}>
              {leadData ? leadData.product_title : 'Loading...'}
            </h1>
            {leadData && (
              <div className="d-flex align-items-center gap-3">
                <span className="badge bg-dark" style={{ fontSize: '0.9rem', fontWeight: '500', padding: '6px 12px' }}>
                  <i className="fas fa-hashtag me-1"></i>
                  {leadData.lead_id}
                </span>
                <span className="text-muted" style={{ fontSize: '0.9rem' }}>
                  <i className="fas fa-file-alt me-1"></i>
                  Lead Details
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
 
      <div className='page-top-formview mb-3'>
        <div className='customer-tab-view leads-tab-view'>
          <Tabs
            defaultActiveKey="overview"
            id="uncontrolled-tab-example"
            onSelect={(key) => {
              if (key === 'quotes') {
                console.log('📊 Quotes tab selected - Fetching quote history...');
                fetchQuoteHistory();
                fetchLatestQuote();
              }
            }}
          >
            {/* OVERVIEW */}
              <Tab eventKey="overview" title="Overview">
  <div className='mt-3'>
 
    {/* ------------------------ Quote Box UI ------------------------ */}
    <div className="card shadow-sm mb-4" style={{ borderRadius: '10px', overflow: 'hidden' }}>
      <div className="card-header" style={{ 
        backgroundColor: '#f8f9fa', 
        borderBottom: '2px solid #e9ecef',
        padding: '1rem 1.25rem'
      }}>
        <h5 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
          Quote Summary
        </h5>
      </div>
      <div className="card-body" style={{ padding: '1.5rem' }}>
        {!leadData ? (
          <div className="text-center py-3">
            <div className="spinner-border text-primary spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2 mb-0 text-muted">Loading lead data...</p>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-baseline gap-3">
                <span className="text-muted small">Total Cost</span>
                {loadingFee ? (
                  <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                    Loading...
                  </span>
                ) : quoteFeeData ? (
                  <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                    £{(quoteFeeData.net || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Net + £{(quoteFeeData.vat || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} VAT = £{(quoteFeeData.gross || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Gross
                  </span>
                ) : (
                  <span style={{ color: '#2c3e50', fontWeight: '600', fontSize: '1.2rem' }}>
                    £{(leadData?.mlmLegalCost || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Net + £{(leadData?.vat || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} VAT = £{(leadData?.totalCost || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Gross
                  </span>
                )}
              </div>
            </div>
            {/* Rate Card Info */}
            {quoteFeeData && (quoteFeeData.partner_name || quoteFeeData.branch_name) && (
              <div className="mt-2">
                <span className="text-muted small">Rate Card: </span>
                <span className="badge bg-info text-white">
                  {quoteFeeData.rate_card_type === 'PARTNER' && quoteFeeData.partner_name ? (
                    <>Partner: {quoteFeeData.partner_name}</>
                  ) : quoteFeeData.rate_card_type === 'BRANCH' && quoteFeeData.branch_name ? (
                    <>Branch: {quoteFeeData.branch_name}</>
                  ) : null}
                </span>
              </div>
            )}
            {leadData?.created_at && (
              <div className="d-flex justify-content-between align-items-center mt-3">
                <span className="text-muted small">
                  {new Date(leadData.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })} {new Date(leadData.created_at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                </span>
                <div>
                  {leadData?.group_code_code && (
                    <span className="badge rounded-pill bg-secondary me-2">{leadData.group_code_code}</span>
                  )}
                  {leadData?.created_by && (
                    <span className="badge rounded-pill bg-info">{leadData.created_by}</span>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Action Buttons */}
      <div className="card-footer bg-light" style={{ borderTop: '1px solid #e9ecef', padding: '1rem 1.25rem' }}>
        <div className="d-flex gap-2 flex-wrap align-items-center">
          {leadData?.status !== 'Instructed' && (
            <>
              <Button
                variant="contained"
                className='text-capitalize'
                onClick={() => setReviseModalShow(true)}
                style={{
                  backgroundColor: '#dc3545',
                  borderColor: '#dc3545',
                  fontSize: '0.875rem',
                  padding: '8px 16px'
                }}
              >
                <EditOutlinedIcon fontSize="small" style={{ marginRight: '6px' }} />
                Revise Quote
              </Button>
              <Button
                variant="outlined"
                className='text-capitalize'
                onClick={handleRegenerateQuote}
                style={{
                  color: '#6c757d',
                  borderColor: '#6c757d',
                  fontSize: '0.875rem',
                  padding: '8px 16px'
                }}
              >
                <RefreshIcon fontSize="small" style={{ marginRight: '6px' }} />
                Regenerate Quote
              </Button>
            </>
          )}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              console.log('🔵 View Quote Detail clicked');
              handleViewQuoteDetail();
            }}
            style={{
              color: '#0d6efd',
              textDecoration: 'none',
              cursor: 'pointer',
              fontSize: '14px'
            }}
            onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
            onMouseOut={(e) => e.target.style.textDecoration = 'none'}
          >
            View Quote Detail
          </a>
        </div>
      </div>
    </div>
 
    {/* ------------------------ End Quote Box ------------------------ */}
    
    {/* Lead Details Card */}
    <div className="card shadow-sm mb-3">
      <div className="card-header" style={{ 
        backgroundColor: '#f8f9fa', 
        borderBottom: '1px solid #e9ecef',
        padding: '0.75rem 1.25rem'
      }}>
        <h6 className="mb-0" style={{ color: '#495057', fontWeight: '600' }}>
          Lead Details
        </h6>
      </div>
      <div className="card-body p-0">
        <table className="table table-hover mb-0">
          <tbody>
            <tr>
              <td className="fw-semibold" style={{ width: '35%', padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                <i className="fas fa-users text-muted me-2"></i>
                Customers
              </td>
              <td style={{ padding: '12px 20px' }}>{leadData?.customers || '-'}</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                <i className="fas fa-pound-sign text-muted me-2"></i>
                Net Estate Value
              </td>
              <td style={{ padding: '12px 20px' }}>£{leadData?.net_value?.toFixed(2) || '0.00'}</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                <i className="fas fa-code text-muted me-2"></i>
                Group Code
              </td>
              <td style={{ padding: '12px 20px' }}>{leadData?.group_code_code || '-'}</td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ padding: '12px 20px', backgroundColor: '#f8f9fa' }}>
                <i className="fas fa-info-circle text-muted me-2"></i>
                Status
              </td>
              <td style={{ padding: '12px 20px' }}>
                <span className="badge bg-primary">{leadData?.status || 'Active'}</span>
              </td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ padding: '12px 20px', backgroundColor: '#f8f9fa', borderBottom: 'none' }}>
                <i className="fas fa-chart-line text-muted me-2"></i>
                Complexity
              </td>
              <td style={{ padding: '12px 20px', borderBottom: 'none' }}>
                {(() => {
                  const complexity = leadData?.complexity || 'Low';
                  const getComplexityColor = (comp) => {
                    switch(comp) {
                      case 'Low': return 'success';
                      case 'Medium': return 'warning';
                      case 'High': return 'danger';
                      default: return 'secondary';
                    }
                  };
                  return <span className={`badge bg-${getComplexityColor(complexity)}`}>{complexity}</span>;
                })()}
              </td>
            </tr>
            <tr>
              <td className="fw-semibold" style={{ padding: '12px 20px', backgroundColor: '#f8f9fa', borderBottom: 'none' }}>
                <i className="fas fa-university text-muted me-2"></i>
                Lender Panel
              </td>
              <td style={{ padding: '12px 20px', borderBottom: 'none' }}>
                {(() => {
                  const lenderPanel = leadData?.lender_panel_id;

                  // If lender panel is populated object
                  if (lenderPanel && typeof lenderPanel === 'object' && lenderPanel.name) {
                    return (
                      <div>
                        <div>
                          <span className="badge bg-info">
                            {lenderPanel.name}
                          </span>
                        </div>
                        {lenderPanel?.lender_numbers && lenderPanel.lender_numbers.length > 0 && (
                          <div style={{ color: '#6c757d', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                        <span style={{ fontWeight: '500' }}>Lender Panel Number: </span>
                            {lenderPanel.lender_numbers.join(', ')}
                          </div>
                        )}
                      </div>
                    );
                  }

                  // If no lender panel selected
                  return <span className="text-muted">Not specified</span>;
                })()}
              </td>
            </tr>
            {leadData?.partner_id && (
              <tr>
                <td className="fw-semibold" style={{ padding: '12px 20px', backgroundColor: '#f8f9fa', borderBottom: 'none' }}>
                  <i className="fas fa-handshake text-muted me-2"></i>
                  Partner
                </td>
                <td style={{ padding: '12px 20px', borderBottom: 'none' }}>
                  {(() => {
                    const partnerId = typeof leadData.partner_id === 'object' ? leadData.partner_id._id : leadData.partner_id;
                    const partner = partners.find(p => p._id === partnerId);
                    if (partner) {
                      return partner.name;
                    }
                    return <span className="text-muted">Not specified</span>;
                  })()}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>


    {/* Action Bar */}
    <div className="card shadow-sm mb-3" style={{ borderRadius: '8px' }}>
      <div className="card-body" style={{ padding: '1rem 1.25rem' }}>
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div className="d-flex gap-2">
            <Button 
              variant="outlined" 
              className='text-capitalize'
              style={{ 
                borderColor: '#dc3545',
                color: '#dc3545',
                fontSize: '0.875rem'
              }}
            >
              <NavLink
                to={`/leads/edit/lss-estate-administration/${lead_id}`}
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <EditOutlinedIcon fontSize="small" style={{ marginRight: '6px' }} />
                Edit Lead
              </NavLink>
            </Button>
            
            <Dropdown>
              <Dropdown.Toggle 
                variant="outline-secondary" 
                className='text-capitalize'
                style={{ fontSize: '0.875rem' }}
              >
                More Actions
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>
                  <Link to="/leads/changestatus" state={{ id: lead_id, title: slugify(leadData?.product_title) }} className="text-decoration-none text-dark">
                    <i className="fas fa-exchange-alt me-2"></i>
                    Change Status
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to="/leads/changegroupcode" state={{ id: lead_id, title: slugify(leadData?.product_title) }} className="text-decoration-none text-dark">
                    <i className="fas fa-code me-2"></i>
                    Change Group Code
                  </Link>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleDeleteLead} className="text-danger">
                  <i className="fas fa-trash-alt me-2"></i>
                  Delete Lead
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          
          <div className="text-muted small">
            <i className="fas fa-calendar-alt me-2"></i>
            Created: {leadData ? new Date(leadData.created_at).toLocaleDateString('en-GB') : 'Loading...'}
            <span className="mx-2">•</span>
            <i className="fas fa-user me-2"></i>
            {leadData?.created_by || 'User'}
          </div>
        </div>
      </div>
    </div>
  </div>
</Tab>
 
 
 
            {/* QUOTES */}
            <Tab eventKey="quotes" title="Quotes">
              <div className="mt-3">
                {(() => {
                  // Use quote history from final_leads_calculations (already includes current quote)
                  const allQuotes = quoteHistory && quoteHistory.length > 0 ? quoteHistory : [];

                  console.log('🎯 All LSS quotes to display:', allQuotes);

                  if (allQuotes.length === 0) {
                    return (
                      <div className="text-center py-5">
                        <i className="fas fa-file-invoice fa-3x text-muted mb-3"></i>
                        <h5 className="text-muted">No Quotes Available</h5>
                        <p className="text-muted">No quotes have been generated yet.</p>
                      </div>
                    );
                  }
                  
                  return (
                    <div className="quote-history-section">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                          <i className="fas fa-history me-2" style={{ color: '#3498db' }}></i>
                          Quote History
                        </h5>
                        <span className="badge bg-primary" style={{ fontSize: '0.9rem', padding: '6px 12px' }}>
                          {allQuotes.length} {allQuotes.length === 1 ? 'Version' : 'Versions'}
                        </span>
                      </div>

                      <div className="timeline" style={{ position: 'relative', paddingLeft: '30px' }}>
                        {/* Timeline line */}
                        <div style={{
                          position: 'absolute',
                          left: '8px',
                          top: '20px',
                          bottom: '20px',
                          width: '2px',
                          backgroundColor: '#e0e0e0'
                        }}></div>

                        {allQuotes.map((quote, index) => {
                          const isActive = quote.isCurrent;
                          const versionLabel = isActive ? 'Current' : (quote.revision_number > 0 ? `Revision ${quote.revision_number}` : 'Original');

                          return (
                            <div key={index} style={{ position: 'relative', marginBottom: '24px' }}>
                              {/* Timeline dot */}
                              <div style={{
                                position: 'absolute',
                                left: '-26px',
                                top: '16px',
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                backgroundColor: isActive ? '#27ae60' : '#95a5a6',
                                border: '3px solid white',
                                boxShadow: isActive ? '0 0 0 2px #27ae60' : '0 0 0 2px #95a5a6',
                                zIndex: 1
                              }}></div>

                              {/* Card */}
                              <div className="card" style={{
                                border: `2px solid ${isActive ? '#27ae60' : '#e9ecef'}`,
                                borderRadius: '12px',
                                boxShadow: isActive ? '0 4px 12px rgba(39, 174, 96, 0.15)' : '0 2px 8px rgba(0,0,0,0.08)',
                                transition: 'all 0.3s ease',
                                backgroundColor: isActive ? '#f8fff9' : 'white'
                              }}>
                                <div className="card-body" style={{ padding: '20px' }}>
                                  <div className="d-flex justify-content-between align-items-start mb-3">
                                    {/* Left: Version & Amount */}
                                    <div className="flex-grow-1">
                                      <div className="d-flex align-items-center gap-2 mb-2">
                                        <i className={`fas ${isActive ? 'fa-check-circle' : 'fa-file-invoice'}`} style={{ color: isActive ? '#27ae60' : '#95a5a6', fontSize: '18px' }}></i>
                                        <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c3e50' }}>
                                          {versionLabel}
                                        </h5>
                                        {isActive && (
                                          <span className="badge" style={{
                                            backgroundColor: '#27ae60',
                                            color: 'white',
                                            padding: '4px 10px',
                                            borderRadius: '6px',
                                            fontSize: '0.75rem',
                                            fontWeight: 600
                                          }}>
                                            CURRENT
                                          </span>
                                        )}
                                      </div>

                                      {/* Date & Time */}
                                      <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
                                        <i className="far fa-clock me-1"></i>
                                        {new Date(quote.created_at).toLocaleDateString('en-GB', {
                                          day: '2-digit',
                                          month: 'short',
                                          year: 'numeric'
                                        })} at {new Date(quote.created_at).toLocaleTimeString('en-GB', {
                                          hour: '2-digit',
                                          minute: '2-digit'
                                        })}
                                      </p>

                                      {/* Source Badge */}
                                      <span className="badge" style={{
                                        backgroundColor: '#95a5a6',
                                        color: 'white',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontSize: '0.7rem'
                                      }}>
                                        {quote.isCurrent ? 'CURRENT QUOTE' : 'HISTORICAL'}
                                      </span>
                                    </div>

                                    {/* Right: Branch/Partner & Action */}
                                    <div className="d-flex flex-column align-items-end gap-2">
                                      {quote.rate_card_type === 'PARTNER' && quote.partner_name ? (
                                        <span className="badge" style={{
                                          backgroundColor: '#e8f4f8',
                                          color: '#3498db',
                                          padding: '6px 12px',
                                          borderRadius: '6px',
                                          fontSize: '0.75rem',
                                          fontWeight: 600
                                        }}>
                                          <i className="fas fa-handshake me-1"></i>
                                          Partner: {quote.partner_name}
                                        </span>
                                      ) : quote.branch_name && (
                                        <span className="badge" style={{
                                          backgroundColor: '#e8f4f8',
                                          color: '#3498db',
                                          padding: '6px 12px',
                                          borderRadius: '6px',
                                          fontSize: '0.75rem',
                                          fontWeight: 600
                                        }}>
                                          <i className="fas fa-building me-1"></i>
                                          Branch: {quote.branch_name}
                                        </span>
                                      )}
                                      <span
                                        style={{
                                          color: '#1976d2',
                                          cursor: 'pointer',
                                          fontSize: '0.875rem',
                                          fontWeight: 500,
                                          textDecoration: 'none',
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          gap: '4px'
                                        }}
                                        onClick={() => handleViewQuoteDetail(quote)}
                                        onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                        onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                      >
                                        <i className="fas fa-eye" style={{ fontSize: '14px' }}></i>
                                        View Quote Detail
                                      </span>
                                    </div>
                                  </div>

                                  {/* Pricing Breakdown */}
                                  <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
                                    <div className="row g-3">
                                      {/* Total Amount - Highlighted */}
                                      <div className="col-md-4">
                                        <div style={{
                                          backgroundColor: isActive ? '#e8f5e9' : '#f8f9fa',
                                          padding: '12px',
                                          borderRadius: '8px',
                                          textAlign: 'center'
                                        }}>
                                          <p className="text-muted mb-1" style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase' }}>
                                            Total Amount
                                          </p>
                                          <h4 className="mb-0" style={{ color: isActive ? '#27ae60' : '#2c3e50', fontWeight: 700 }}>
                                            £{Number(quote.totalCost).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </h4>
                                        </div>
                                      </div>

                                      {/* Legal Costs */}
                                      <div className="col-md-4">
                                        <div style={{ padding: '12px' }}>
                                          <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                            <i className="fas fa-balance-scale me-1"></i>
                                            Legal Costs
                                          </p>
                                          <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                            £{Number(quote.mlmLegalCost).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </h6>
                                        </div>
                                      </div>

                                      {/* VAT */}
                                      <div className="col-md-4">
                                        <div style={{ padding: '12px' }}>
                                          <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                            <i className="fas fa-receipt me-1"></i>
                                            VAT Included
                                          </p>
                                          <h6 className="mb-0" style={{ color: '#2c3e50', fontWeight: 600 }}>
                                            £{Number(quote.vat).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </Tab>
 
            {/* NOTES */}
            <Tab eventKey="notes" title="Notes">
              <Notes lead_id={lead_id} product_id= {leadData?.product_id}/>
            </Tab>
 
            {/* COMMUNICATION */}
            <Tab eventKey="communication" title="Communication">
  <div className='communication-table'>
    <Dropdown>
      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
        Contact Attempt ({contactAttempts})
      </Dropdown.Toggle>
 
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => handleUpdateContactAttempt('increase')}>
          <MailOutlineIcon fontSize="small" /> &nbsp; Increase Contact Attempt Count
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleUpdateContactAttempt('reset')}>
          <CallOutlinedIcon fontSize="small" /> &nbsp; Reset
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  </div>
</Tab>
 
 
            {/* APPOINTMENT / TASKS */}
            <Tab eventKey="appointment" title="Tasks">
              <div className='mt-4'>
                <div className="text-center py-5">
                  <i className="fas fa-tasks fa-3x text-muted mb-3"></i>
                  <h5 className="text-muted">No Tasks Available</h5>
                  <p className="text-muted">No tasks have been created for this lead yet.</p>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
 
      <MyVerticallyCenteredModal 
        show={modalShow} 
        onHide={() => {
          setModalShow(false);
          setSelectedQuote(null);
        }}
        quoteData={selectedQuote}
        leadData={leadData}
      />
      
      {/* Revise Quote Modal */}
      <ReviseQuoteModal 
        show={reviseModalShow} 
        onHide={() => setReviseModalShow(false)}
        leadData={leadData}
        estateCosts={estateCosts}
        authToken={authCtx.token}
        onReviseQuote={handleReviseQuote}
      />
    </>
  );
}